import { render, staticRenderFns } from "./PaymentPosnetForm.vue?vue&type=template&id=13f122b6"
import script from "./PaymentPosnetForm.vue?vue&type=script&lang=js"
export * from "./PaymentPosnetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports